import { IconProps } from "../../utils/global-types/global-types";

const PauseIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.5 3.003h3c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-16c0-.55.45-1 1-1m8 0h3c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-16c0-.55.45-1 1-1"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default PauseIcon;
